import { Trans } from '@lingui/macro'
import HelpOutline from '@material-ui/icons/HelpOutline'
import React, { useState } from 'react'
import { IconButton } from 'webbook-airways'
import HelpLoader from './HelpLoader'

export default function HelpHeader({ type, id, size }) {
  const [showHelp, setShowHelp] = useState(false)

  return (
    <div
      style={{
        backgroundColor: showHelp
          ? 'rgba(255, 255, 255, 1.0)'
          : 'rgba(255, 255, 255, 0.0)'
      }}
    >
      <IconButton
        title={<Trans>Help</Trans>}
        icon={HelpOutline}
        size={size || 16}
        onClick={() => setShowHelp(!showHelp)}
      />
      <HelpLoader type={type} id={id} show={showHelp} />
    </div>
  )
}
